import { moduleApi } from '~/apis/module';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IQueryGetModule, UpsertModuleWatchProgressBody } from '~/utils/interface/module';
import {
  ADMIN_UPDATE_MODULE_WATCH_PROGRESS,
  GET_LIST_MODULE,
  UPSERT_MODULE_WATCH_PROGRESS,
} from '~/utils/constants/actionType';
import { IBodyAdminUpdateModuleWatchProgress } from '~/utils/interface/studentProgress';

export const upsertModuleWatchProgress = createAsyncThunk(
  UPSERT_MODULE_WATCH_PROGRESS,
  async ({ moduleId, body }: { moduleId: number; body: UpsertModuleWatchProgressBody }, { rejectWithValue }) => {
    try {
      const res = await moduleApi.upsertModuleWatchProgress(moduleId, body);
      return {
        moduleId,
        body,
        response: res.data,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getModules = createAsyncThunk(GET_LIST_MODULE, async (payload: IQueryGetModule, { rejectWithValue }) => {
  try {
    const res = await moduleApi.getModules(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const adminUpdateModuleWatchProgress = createAsyncThunk(
  ADMIN_UPDATE_MODULE_WATCH_PROGRESS,
  async (
    { moduleId, body }: { moduleId: string; body: IBodyAdminUpdateModuleWatchProgress },
    { rejectWithValue }
  ) => {
    try {
      const res = await moduleApi.adminUpdateModuleWatchProgress(moduleId, body);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
